export const NODE_TYPE = {
  SPECIALIZED: 'specialized',
  CONDITIONAL: 'conditional',
  FOR_LOOP: 'for_loop',
  CONDITION: 'condition',
  WEBHOOK: 'webhook',
  SCHEDULED: 'scheduled',
  MESSAGE: 'message',
  EMAIL: 'email',
  NESTED_WORKFLOW: 'nested_workflow',
} as const;

export type NodeType = (typeof NODE_TYPE)[keyof typeof NODE_TYPE];
